import axios from "axios";
import { responseError } from "./UtilService";

const api_url = process.env.REACT_APP_API_URL + "/pedidos";

export async function getPedidos(fechaDesde, fechaHasta, estado = "") {
    console.log(`deberia llamar a api con fechaDesde=${fechaDesde}, fechaHasta=${fechaHasta}, estado=${estado}`);

    let params = "";
    if (fechaDesde) {
        params += "?fechaDesde="+fechaDesde;
    }
    if (fechaHasta) {
        params += (params===""?"?fechaHasta="+fechaHasta:"&fechaHasta="+fechaHasta);
    }
    if (estado !== "") {
        params += (params===""?"?estado="+estado:"&estado="+estado);
    }
    try {
        let resp = await axios.get(api_url+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err,"Hubo un error al obtener datos de pedidos desde el servidor.");
    }
}

export async function getPedidosEntrega(fechaDesde, fechaHasta, marca = undefined, entregado = "N") {
    console.log(`deberia llamar a api con fechaDesde=${fechaDesde}, fechaHasta=${fechaHasta}, marca=${marca}, entregado=${entregado}`);

    let params = "";
    if (fechaDesde) {
        params += "?fechaDesde="+fechaDesde;
    }
    if (fechaHasta) {
        params += (params===""?"?fechaHasta="+fechaHasta:"&fechaHasta="+fechaHasta);
    }
    if (marca) {
        params += (params===""?"?marca="+marca:"&marca="+marca);
    }
    if (entregado !== "") {
        params += (params===""?"?entregado="+entregado:"&entregado="+entregado);
    }
    try {
        let resp = await axios.get(api_url+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err,"Hubo un error al obtener datos de pedidos desde el servidor.");
    }
}

export async function nuevoPedido(data) {
    try {
        let resp = await axios.post(api_url,data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al guardar el pedido en el servidor.");
            }
            //develver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //develver error de red
        }
        return resp;
    }
}

export async function editarPedido(id, data) {
    try {
        let resp = await axios.put(api_url+`/${id}`,data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al guardar el pedido en el servidor.");
            }
            //devolver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //devolver error de red
        }
        return resp;
    }
}

export async function entregaPedido(id, entregar) {
    try {
        let data = {
            entregado: entregar
        };
        let resp = await axios.put(api_url+"/entrega"+`/${id}`,data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al entregar el pedido en el servidor.");
            }
            //devolver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //devolver error de red
        }
        return resp;
    }
}

export async function getPedido(id) {
    try {
        let resp = await axios.get(api_url+"/"+id);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err,"Hubo un error al obtener el pedido en el servidor.");
    }
}

export async function deletePedido(id) {
    try {
        let resp = await axios.delete(api_url+"/"+id);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al borrar el pedido en el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}